/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/AddedBy/Content/Content"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let connectionUserVaxiomPersonValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'user.vaxiom_person',
format: fromFormat.patientName,
})
let connectionCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'created_at',
format: fromHelpers.formatDate,
})
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 width={300}
 height={90}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsWhite,'--pl-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Connection metadata"
 color={dtColorsNeutral400}
 weight="medium"
 marginBottom={dtSpaceMs}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Added by"
 color={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="connection.user.vaxiom_person"
 format="/Data/format.js patientName"
 text={connectionUserVaxiomPersonValueData}
/>
</div>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Added on"
 color={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="connection.created_at"
 format="helpers.js formatDate"
 text={connectionCreatedAtValueData}
/>
</div>
</div>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}